<template>
    <html data-wf-page="5b17a0c3e17ccd5653bd4f4e" data-wf-site="5b1755d5269b9c5142d82ca3">
<head>
  <meta charset="utf-8">
  <title>Cabinet Manager | Export Tool</title>
  <meta content="Cabinet Manager | Export Tool" property="og:title">
  <meta content="width=device-width, initial-scale=1" name="viewport">
  <link href="../static/css/exceptions.css" rel="stylesheet" type="text/css">
</head>
<body class="body-2">
  <MobileNav :project="project" :current-page="'statistics'"></MobileNav>
  <div class="wholewrapper">
    <div class="div-block-24">
      <NavSideBar :current-page="'statistics'" :project="project"></NavSideBar>
      <div class="contentcontainer">
        <div class="contenttop">
          <div class="div-block-30">
            <div class="projectselector">
              <el-dropdown trigger="click" @command="switchProject">
                <span class="el-dropdown-link" style="color: #fff; font-weight: bold;">{{ project.name }}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="project in projectList"
                    v-show="project.status !== 'closed'"
                    :key="project.id"
                    :command="project.id">{{ project.name }}
                  </el-dropdown-item>
                  <el-dropdown-item divided
                    :command="''">All Projects
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <SignInButton :user="user" @login="$emit('login')"></SignInButton>
          </div>
          <div class="div-block-32">
            <div class="text-block-16">Export Tool</div>
          </div>
        </div>
        <div class="contentdown">
          <div class="downcontentdrawings">
              <h3>Unit Selector</h3>
                  <el-transfer
                    v-model="selectedUnitsIndex"
                    :data="unitOptionList"
                    :titles="['Select All', 'Select All']"
                    filterable :filter-method="unitFilter" filter-placeholder="Eg. 101, #3(All tier 3 units), @5(Whole 5th floor)">
                  </el-transfer>
              <el-button @click="downloadSheet" type="primary" round plain style="margin-top:24px;" :loading="sheetLoading" :disabled="selectedUnits.length === 0"> {{ sheetLoading ? 'Exporting' : 'Export Drawing/Packing Sheet(xlsx)'}} </el-button>
              <el-button @click="downloadPackingPDF" type="primary" round plain style="margin-top:24px;" :loading="pdfLoading" :disabled="selectedUnits.length === 0"> {{pdfLoading ? 'Exporting': 'Export Packing PDF(pdf)'}}</el-button>
              <el-button @click="downloadPdfSheet" type="primary" round plain style="margin-top:24px;" :loading="pdfSheetLoading" :disabled="selectedUnits.length === 0 || selectedUnits.length > 25"> {{pdfSheetLoading ? 'Exporting': 'Export Packing Sheet(pdf)'}}</el-button>
          </div>
          <div class="powereddiv">
            <div class="div-block-14">
              <div class="text-block-9">Powered by </div>
              <a href="http://studioscreation.com" target="_blank" class="poweredlink w-inline-block">
                <div class="text-block-10">Studio S, Inc.</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</html>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">WebFont.load({  google: {    families: ["Ubuntu:300,300italic,400,400italic,500,500italic,700,700italic","Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic","Dosis:regular,500,600,700,800"]  }});</script>

<!-- [if lt IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/html5shiv/3.7.3/html5shiv.min.js" type="text/javascript"></script><![endif] -->
<script type="text/javascript">!function(o,c){var n=c.documentElement,t=" w-mod-";n.className+=t+"js",("ontouchstart"in o||o.DocumentTouch&&c instanceof DocumentTouch)&&(n.className+=t+"touch")}(window,document);</script>
<script src="https://code.jquery.com/jquery-3.3.1.min.js" type="text/javascript" integrity="sha256-FgpCb/KJQlLNfOu91ta32o/NMZxltwRo8QtmkMRdAu8=" crossorigin="anonymous"></script>
<script src="../static/js/t2-cabinets-management-system.js" type="text/javascript"></script>
<script src="../static/js/xlsx-populate.min.js" type="text/javascript"></script>
<!-- [if lte IE 9]><script src="https://cdnjs.cloudflare.com/ajax/libs/placeholders/3.0.2/placeholders.min.js"></script><![endif] -->

<script>
import { db, xp } from '../main'
import SignInButton from './SignInButton'
import AddDrawingForm from './AddDrawingForm'
import EditDrawingForm from './EditDrawingForm'
import NavSideBar from "./NavSideBar"
import MobileNav from "./MobileNav"
import exportService from '../../static/js/exportService'
import drawingService from '../../static/js/drawing'

export default {
  name: 'ProjectStatistics',
  props: ['user'],
  data () {
    return {
      currentProject: "NO_PROJECT_SELECTED",
      projectList: [],
      project: {},
      remoteUnits: [],
      unitOptionList: [],
      selectedUnitsIndex: [],
      unitFilter: unitFilter,
      menuNav: false,
      pdfLoading: false,
      sheetLoading: false,
      pdfSheetLoading: false
    }
  },
  firestore () {
    return {
      projectList: db.collection('project_list').where('version', '==', 2).orderBy('last_open_date','desc').limit(15),
    }
  },
  computed: {
    selectedUnits: function () {
      let unitOptionList = this.unitOptionList
      let selectedUnits = []
      for (var i = 0; i < this.selectedUnitsIndex.length; i++) {
        selectedUnits.push(unitOptionList[this.selectedUnitsIndex[i]])
      }
      console.log('selected units =>', selectedUnits)
      return selectedUnits
    }
  },
  created: function () {
    this.currentProject = this.$route.query.project
    // console.log('current project init, link to project')
    this.initData()
  },
  watch: {
    $route: function () {
      this.currentProject = this.$route.query.project
    },
    currentProject: function () {
      // console.log('current project changed, link to new project')
      this.initData()
    },
    remoteUnits: function () {
      // watch unit data from database, if changed, compute new data source for transfer window
      let remoteUnits = this.remoteUnits
      let unitOptionList = []
      for(var i = 0; i < remoteUnits.length; i++){
        let unit = remoteUnits[i]
        let transUnit = unit
        transUnit.label = unit.display
        transUnit.key = i
        unitOptionList.push(transUnit)
      }
      unitOptionList.sort((unitA, unitB) => {
        let aFloor = parseInt(unitA.floor)
        let bFloor = parseInt(unitB.floor)

        // floor always a number
        if (aFloor === bFloor) {
          // compare tier (can be NaN if parse)
          let aTier = parseInt(unitA.tier)
          let bTier = parseInt(unitB.tier)
          if (isNaN(aTier) && isNaN(bTier)) {
            return unitA.tier.localeCompare(unitB.tier)
          } else if (isNaN(aTier) && !isNaN(bTier)) {
            return 1
          } else if (!isNaN(aTier) && isNaN(bTier)) {
            return -1
          } else {
            return aTier - bTier
          }
        } else {
          return aFloor - bFloor
        }
      })
      // re-assign the key
      for (let i = 0; i < unitOptionList.length; i++ ) {
        unitOptionList[i].key = i
      }
      this.unitOptionList = unitOptionList
      console.log('unit option list =>',unitOptionList)
    }
  },
  methods: {
    switchProject: function (projectId) {
      // console.log('switch to =>', projectId)
      if (projectId !== ''){
        this.$router.push({
          path: 'statistics',
          query: {
            project: projectId
          }
        })
      } else {
        this.$router.push({
          path: '/'
        })
      }
    },
    initData: async function () {
      if (this.currentProject === 'NO_PROJECT_SELECTED') {
        return
      }
      await drawingService.initService(this.currentProject)
      this.$bind('project', db.collection('project').doc(this.currentProject))
      this.$bind('remoteUnits', db.collection('units').where('projectId','==', this.currentProject).orderBy('building').orderBy('floor').orderBy('tier'))
    },
    downloadSheet: async function () {
      if(this.selectedUnits.length === 0) {
        this.$message({
          message: 'Please select at least on unit',
          type: 'warning'
        })
        return
      }
      this.sheetLoading = true
      let address
      try {
        address = this.project.delivery.address
      } catch (error){
        address = 'Address not set'
      }
      let exportResult = await exportService.generateSheet(this.selectedUnits, address, this.project.name)
      if (!exportResult) {
        this.$message.error('Sorry! Generation failed, please try again or contact support team.')
      }
      this.sheetLoading = false
    },
    downloadPackingPDF: async function () {
      if(this.selectedUnits.length === 0) {
        this.$message({
          message: 'Please select at least on unit',
          type: 'warning'
        })
        return
      }
      this.pdfLoading = true
      let address
      try {
        address = this.project.delivery.address
      } catch (error){
        address = 'Address not set'
      }
      let exportResult = await exportService.generatePdf(this.selectedUnits, address, this.project.name)
      if (!exportResult) {
        this.$message.error('Sorry! Generation failed, please try again or contact support team.')
      }
      this.pdfLoading = false
    },
    downloadPdfSheet: async function () {
      if (this.selectedUnits.length === 0 || this.selectedUnits.length > 25) {
        this.$message({
          message: 'Unit amount must between 1 and 25',
          type: 'warning'
        })
        return
      }
      this.pdfSheetLoading = true
      let headerInfo = {
        projectName: this.project.name
      }
      headerInfo.client = this.project.client || 'Client Name Not Provided'
      if (this.project.delivery) {
        headerInfo.address = this.project.delivery.address || 'Address Not Provided'
        headerInfo.phone = this.project.delivery.phone || 'Phone Not Provided'
      } else {
        headerInfo.address = 'Address Not Provided'
        headerInfo.phone = 'Phone Not Provided'
      }
      let exportResult = await exportService.generatePdfSheet(this.selectedUnits, headerInfo)
      if (!exportResult) {
        this.$message.error('Sorry! Generation failed, please try again or contact support team.')
      }
      this.pdfSheetLoading = false
    }
  },
  components: {
    SignInButton,
    NavSideBar,
    MobileNav
  }
}

function unitFilter (query,unit) {
  let queryGroup = query.split(',')

  for (let singleQuery of queryGroup) {
    if(unit.display.indexOf(singleQuery) !== -1){
      return true
    }
    if (singleQuery.indexOf('@') !== -1) {
      let floor = singleQuery.replace('@','')
      if (unit.floor == floor) {
        return true
      }
    }
    if (singleQuery.indexOf('#') !== -1) {
      let tier = singleQuery.replace('#','')
      if (unit.tier == tier) {
        return true
      }
    }
  }
  return false
}

</script>



// WEBPACK FOOTER //
// src/components/ProjectStatistics.vue